import { useParams, Link } from "react-router-dom";
import { BLOG_POSTS } from "@/data/content";
import { ArrowLeft } from "lucide-react";

export default function BlogPost() {
    const { slug } = useParams();
    const post = BLOG_POSTS.find((p) => p.slug === slug);

    if (!post) {
        return (
            <div className="container-editorial py-32 text-center">
                <h1 className="font-serif text-4xl">Post not found</h1>
                <Link to="/blog" className="text-primary underline mt-4 inline-block">Back to blog</Link>
            </div>
        );
    }

    return (
        <article className="container-editorial py-16 md:py-24 max-w-3xl">
            <Link to="/blog" data-testid="back-to-blog" className="inline-flex items-center gap-2 text-sm text-stone-500 hover:text-primary mb-8">
                <ArrowLeft className="h-4 w-4" /> Back to blog
            </Link>
            <p className="label-eyebrow text-accent">{post.category} · {post.readingTime} min · {post.date}</p>
            <h1 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight mt-3">{post.title}</h1>
            <div className="aspect-[16/9] overflow-hidden rounded-lg border border-stone-200 mt-10">
                <img src={post.cover} alt={post.title} className="w-full h-full object-cover" />
            </div>
            <div className="prose prose-stone max-w-none mt-10 text-lg text-stone-700 leading-relaxed whitespace-pre-line">
                {post.content}
            </div>
        </article>
    );
}
